import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from '@/core/router'
import i18n from '@/i18n'
import moment from 'moment'
import './style.css'
import './assets/index.css'
import { registerSW } from 'virtual:pwa-register'

import { MotionPlugin } from '@vueuse/motion'
import { permissionPlugin } from './core/permissions/plugin'
import { notifyUiNeedsRefresh, startUiVersionWatcher } from '@/core/app/uiVersionWatch'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(MotionPlugin)
app.use(permissionPlugin)
app.provide('$t', i18n.global.t)

app.config.globalProperties.$dt = moment
app.provide('$dt', moment)

if (localStorage.getItem('accessToken')) {
  console.warn('Auth store is not available. Token handling is disabled.')
}

let updateSW: ((reloadPage?: boolean) => Promise<void>) | null = null

// Production only: register SW; version toast owns the refresh UX (no auto-reload).
if (import.meta.env.PROD) {
  updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      // New SW waiting — same sticky toast as version.json mismatch.
      notifyUiNeedsRefresh()
    },
    onRegisteredSW(_swUrl, registration) {
      // Long-lived tabs: poll for a new service worker every 60s.
      if (!registration) return
      window.setInterval(() => {
        void registration.update()
      }, 60_000)
    },
  })
}

app.mount('#app')

// Auto-recover from stale chunks when a new release is deployed
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  const key = 'fcrm_preload_reload'
  const lastReload = Number(sessionStorage.getItem(key) || 0)
  if (Date.now() - lastReload > 5000) {
    sessionStorage.setItem(key, String(Date.now()))
    window.location.reload()
  }
})

startUiVersionWatcher({ updateSW })
